<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="add()">新增</Button>
		</div>
		<div class="query">
			<div class="checkbox">

			</div>
			<Input search enter-button placeholder="优惠券备注查询" v-model="query.like" style="width: 500px;" @on-search="onsearch"   />
		</div>
		<Table border :columns="columns12" :data="data6" :loading="loading">
			<template slot-scope="{ row, index }" slot="action">
				<Button type="primary" size="small" style="margin-right: 5px" @click="update(row.id)">修改</Button>
				<Button type="primary" size="small" style="margin-right: 5px" @click="ckglsb(row.id)">查看设备</Button>
				<!-- <Button @click="forbidden(row.id)" size="small" style="margin-right: 5px" class="delete">禁用/启用</Button> -->
				<Modal v-model="modal2" width="360">
					<p slot="header" style="color:#f60;text-align:center">
						<Icon type="ios-information-circle"></Icon>
						<span>修改状态</span>
					</p>
					<div style="text-align:center">
						<p>确定修改？</p>
					</div>
					<div slot="footer">
						<Button type="error" size="large" long :loading="modal_loading" @click="updteState()">确定</Button>
					</div>
				</Modal>
			</template>
		</Table>
		<div class="my-page">
			<page :total="total" v-if="showPage" @updatePage="updatePage" @updateSize="updateSize"></page>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	export default {
		data() {
			return {
				showPage:true,
				loading: false,
				total: 0,
				query: { //查询参数
					page: 0,
					size: 10,
					like:''
				},
				modal2: false,
				modal_loading: false,
				deleteId: '',
				columns12: [ {
						title: 'id',
						key: 'id',
						width:120,
						align: 'center',
						fixed :'left'
					},
					{
						title: '备注',
						key: 'remark',
						width:150,
						align: 'center',
					},
					{
						title: '开始时间',//
						key: 'beginTime',
						width:180,
						align: 'center',
					},
					{
						title: '结束时间',
						key: 'overTime',
						width:180,
						align: 'center',
					},
					{
						title: '满减',
						key: 'minMoney',
						width:150,
						align: 'center',
						render: (h, params) => {
							return h("div","满"+params.row.minMoney/100+"减"+params.row.reduceMoney/100) 
						}
					},
					{
						title: '状态',
						key: 'isUse',
						width:150,
						align: 'center',
						render: (h, params) => {
							if(params.row.isUse){
								return h("div","正常") 
							}else{
								return h("div","停用") 
							}
							
						}
					},
					{
						title: '类型',
						key: 'couponType',
						width:150,
						align: 'center',
						render: (h, params) => {
							if(params.row.couponType=="PLQ"){
								return h("div","品类券") 
							}else if(params.row.couponType=="DPQ"){
								return h("div","单品券") 
							}else{
								return h("div","满减券")
							}
							
						}
					},
					{
						title: '品类名称',
						width:150,
						align: 'center',
						key: 'typeName'
					},
					{
						title: '商品名称',
						width:150,
						align: 'center',
						key: 'commName'
					},
					{
						title: '标识',
						width:150,
						align: 'center',
						key: 'couponCode'
					},
					{
						title: '最大数量',
						width:150,
						align: 'center',
						key: 'maxNumber'
					},
					{
						title: '已领取数量',
						width:150,
						align: 'center',
						key: 'useNumber'
					},
					{
						title: '二维码',
						width:300,
						align: 'center',
						key: 'qrCode'
					},
					{
						title: '下载地址',
						width:300,
						align: 'center',
						key: 'qrCodeImg'
					},
					
					{
						title: '发放人',
						key: 'empName',
						width:150,
						align: 'center',
					},
					{
						title: '录入时间',
						key: 'createdTime',
						width:150,
						align: 'center',
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center',
						fixed :'right'
					}
				],
				data6: [
					
				]

			}
		},
		methods: {
			
			forbidden(id) {
				this.deleteId = id
				this.modal2 = true
			},
			onsearch(){
				let _this=this
				_this.query.page=0
				
				//重新渲染子组件
				this.showPage = false
				this.$nextTick(() => {
					this.showPage = true
				}) 
				_this.ajaxPage()
			},
			ret() { //返回上一页
				this.$router.go(-1)
			},
			ckglsb(id) { //修改
				this.$router.push({
					name: 'jm/platform/coupon/list/mac',
					query: {
						id: id
					}
				})
			},
			update(id) { 
				this.$router.push({
					name: 'jm/platform/coupon/update',
					query:{
						id:id
					}
				})
			},
			add() { 
				this.$router.push({
					name: 'jm/platform/coupon/add'
				})
			},
			
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			ajaxPage() {
				let _this=this
				this.loading = true
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/coupon/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.coupons.totalElements
						_this.data6 = data.coupons.content
						
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			},
			updteState() {
				let _this=this
				if (this.deleteId == "") {
					this.$Message.error('参数错误，请刷新页面后重试!');
				} else {
					http.http({
					    //这里是你自己的请求方式、url和data参数
					    method: 'post',
					    url: http.url + '/plat/jm/emp/update/state',
					    data: {id: _this.deleteId},
						_this: _this,
						success: function(data) {
							_this.modal_loading = false;
							_this.modal2 = false;
							_this.$Message.success('修改成功！！！');
							_this.ajaxPage()
						}
					    //假设后台需要的是表单数据这里你就可以更改
					  })
					
				}
			},
		},
		components: {
			page
		},
		created() {
			this.ajaxPage();
		}


	}
</script>
<style scoped="scoped">
	.ivu-table-cell {
		padding-left: 0px !important;
	}

	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}

	.my-page {
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}

	.ivu-table-cell {
		padding-left: 0px;
	}

	.query {
		display: flex;
		justify-content: space-between;
		margin: 20px 0px 20px 0px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/platform/coupon/list.vue